import React from 'react';
import "./Navbar.css"

function Navbar() {
  return (
    <div className='navbar'>
        <div className='navbar-heading'>
            Aleo Pay
        </div>
    </div>
  )
}

export default Navbar